import { auth, db } from './firebase';
import { 
  createUserWithEmailAndPassword,
  UserCredential
} from 'firebase/auth';
import { 
  collection, 
  addDoc, 
  getDocs,
  doc,
  updateDoc,
  onSnapshot,
  query,
  orderBy,
  Unsubscribe,
  DocumentData,
  QuerySnapshot
} from 'firebase/firestore';
import { Driver, CreateDriverDto, UpdateDriverDto } from '../types/driver.types';

export class DriversService {
  private static COLLECTION_NAME = 'drivers';

  static async createDriver(driverData: CreateDriverDto): Promise<Driver> {
    try {
      // Create auth user
      const userCredential: UserCredential = await createUserWithEmailAndPassword(
        auth,
        driverData.email,
        driverData.password
      );
      
      // Create driver document
      const driverDoc = {
        uid: userCredential.user.uid,
        name: driverData.name,
        email: driverData.email,
        phone: driverData.phone,
        vehicleId: driverData.vehicleId,
        active: true,
        createdAt: new Date()
      };
      
      const docRef = await addDoc(collection(db, this.COLLECTION_NAME), driverDoc);
      
      return {
        id: docRef.id,
        ...driverDoc
      } as Driver;
    } catch (error) {
      console.error('Error creating driver:', error);
      throw error;
    }
  }

  static async updateDriver(driverId: string, data: UpdateDriverDto): Promise<void> {
    try {
      const driverRef = doc(db, this.COLLECTION_NAME, driverId);
      await updateDoc(driverRef, {
        ...data,
        updatedAt: new Date()
      });
    } catch (error) {
      console.error('Error updating driver:', error);
      throw error;
    }
  }

  static subscribeToDrivers(callback: (drivers: Driver[]) => void): Unsubscribe {
    const q = query(
      collection(db, this.COLLECTION_NAME),
      orderBy('createdAt', 'desc')
    );
    
    return onSnapshot(q, (snapshot: QuerySnapshot<DocumentData>) => {
      const drivers: Driver[] = [];
      snapshot.forEach((doc) => {
        drivers.push({
          id: doc.id,
          ...doc.data()
        } as Driver);
      });
      callback(drivers);
    });
  }
}